import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
function Music() {
    return (
        <>
      
 
  <FontAwesomeIcon icon="fa-solid fa-music" className="fa-lg"  />
  

  
      
      </>
    )
  }
  
  export default Music
  